module.exports = __webpack_public_path__ + "img/020020.b94841f7.png";